<script lang="ts">
	interface Props {
		elapsedMs: number
	}

	let { elapsedMs }: Props = $props()

	const time = $derived.by(() => {
		const s = Math.floor(elapsedMs / 1000)
		return `${String(Math.floor(s / 60)).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`
	})
</script>

<div class="timer-wrapper">
	<span class="text-base text-[#001626E5]">{time}</span>
</div>

<style>
	.timer-wrapper {
		flex: none;
		display: inline-block;
		width: 46px;
	}
</style>
